module.exports = __webpack_public_path__ + "img/sbjr.baf72171.png";